// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2EWle","buttons":"Footer_buttons__3Zef_"};